import 'whatwg-fetch';
import Utils from '../util/ac-utils';
import gsap from 'gsap';

export default function filters(postType, callback, mainScroll) {
	/* Set Filter Data position on available window width */
	let termFilters = document.getElementsByClassName('filter-data');

	window.onload = function() {
		requestAnimationFrame(function() {
			for (let index = 0; index < termFilters.length; index++) {
				const filter = termFilters[index];
				let filterMargin = window.innerWidth - filter.getBoundingClientRect().right;

				if (filterMargin < 0) {
					filter.style.right = '0';
					filter.style.left = 'unset';
				}
			}
		});
	};

	document.querySelectorAll('.placeholder').forEach(placeholder => {
		placeholder.addEventListener('click', event => {
			if (!event.target.matches('.placeholder')) {
				return;
			}

			// Toggle Placeholder and Respective Filter List
			event.target.classList.toggle('open');
			event.target.parentNode.classList.toggle('open');
			event.target.nextElementSibling.classList.toggle('open');
		});
	});

	// Select change
	let filterSelects = document.getElementsByClassName('filter-select');
	for (let index = 0; index < filterSelects.length; index++) {
		const select = filterSelects[index];
		select.addEventListener('change', function(ev) {
			document.querySelector('.term[data-id="' + ev.target.selectedOptions[0].dataset.id + '"]').click();
		});
	}

	/* Hide filters on focusout */
	document.addEventListener('focusout', event => {
		let target = event.target;

		if (!target.matches('.placeholder')) {
			return;
		}

		target.classList.remove('open');
		target.parentNode.classList.remove('open');
		target.nextElementSibling.classList.remove('open');
	});

	/* Listen for term clicks */
	let clearSelection = document.getElementById('clearSelection');
	document.addEventListener('click', event => {
		let target = event.target;

		if (!target.matches('.term')) {
			return;
		}

		// Set active term
		target.parentNode.dataset.term = target.dataset.id;
		let placeholder = target.parentNode.previousElementSibling;

		// Set placeholder as chosen term
		placeholder.getElementsByTagName('span')[0].innerHTML = target.innerHTML;
		placeholder.classList.add('chosen');

		gsap.to(clearSelection, {
			duration: 0.3,
			autoAlpha: 1,
			ease: 'power4.in',
		});

		if (target.parentNode.dataset.postType == 'sodecia_location') {
			return;
		}
		getPostsByTerms(event);
		newGrid.style.display = 'flex';
	});

	// Clear Selection
	let loadMoreContainer = document.getElementById('load-more-container'),
		newGrid = document.getElementById('new-container');

	/* Hide Filters on Scroll */
	if (mainScroll) {
		mainScroll.on('scroll', () => {
			let openPlaceholder = document.querySelector('.placeholder.open');

			if (openPlaceholder) {
				openPlaceholder.classList.remove('open');
				openPlaceholder.nextElementSibling.classList.remove('open');
				openPlaceholder.parentNode.classList.remove('open');
			}
		});
	}

	/* Show Search Results */
	let searchResults = document.getElementById('search-results'),
		searchInput = document.getElementById('input-search');

	searchInput.addEventListener('focusin', () => {
		searchResults.classList.add('open');
		searchResults.parentNode.classList.add('open');
	});

	searchInput.addEventListener('focusout', () => {
		searchResults.classList.remove('open');
		searchResults.parentNode.classList.remove('open');
	});

	/* Listen for search results clicks */
	document.addEventListener('click', event => {
		let target = event.target;

		if (!target.matches('.result-link')) {
			return;
		}
		event.preventDefault();
		event.stopImmediatePropagation();
		event.stopPropagation();
	});

	// Stop the scroll event when users hovers on search results
	if (mainScroll) {
		searchResults.addEventListener('mouseenter', () => {
			mainScroll.stop();
		});

		searchResults.addEventListener('mouseleave', () => {
			mainScroll.start();
		});
	}

	let getPostsByTerms = ev => {
		let placeholder = ev.target.parentNode.previousElementSibling;

		// Set placeholder as chosen term
		placeholder.getElementsByTagName('span')[0].innerHTML = ev.target.innerHTML;
		placeholder.classList.add('chosen');

		let allTerms = [];

		for (let index = 0; index < termFilters.length; index++) {
			const term = termFilters[index];
			let termTax = term.dataset.tax;

			if (termTax.length > 0) {
				allTerms[index] = {
					taxonomy: termTax,
					field: 'term_id',
					include_children: false,
					terms: [],
					operator: 'AND',
				};
			}

			if (term.dataset.term) {
				allTerms[index].terms.push(parseInt(term.dataset.term));
			}
		}

		let utils = new Utils(),
			fullPath = utils.getFullPath(),
			getPostsEndpoint = '/wp-json/sodecia/v1/get_posts_by_terms/',
			data = {
				allTerms: allTerms,
				postType: postType,
			};

		if (loadMoreContainer) {
			gsap.to(loadMoreContainer, {
				duration: 0,
				autoAlpha: 1,
			});
		}

		fetch(fullPath + getPostsEndpoint, {
			method: 'post',
			headers: {
				'Accept': 'application/json, text/plain, */*',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})
			.then(res => res.json())
			.then(res => callback(res));
	};
}



// WEBPACK FOOTER //
// ./scripts/components/filters.js